import { useMutation } from "react-query";
import { addFileCategory } from "../../../../../actions/Utilities/FileCategory";
import { toast } from "components/toastNotification";
import { addStateFileCategory, fileCategoryReFetching } from "../atoms/atoms";
import { useRecoilState, useSetRecoilState } from "recoil";
import { IFileCategory } from "../types";

const useAddFileCategory = () => {
  const setActionAddState = useSetRecoilState(addStateFileCategory);
  const [isReFetching, setIsReFetching] = useRecoilState(
    fileCategoryReFetching
  );
  const { mutate } = useMutation(
    (NewData: IFileCategory) => addFileCategory(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding File Category failed", res.Message, "error");
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "File Category Added Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `File Category Added Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Adding File Category failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Adding File Category failed",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Adding File Category failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Adding File Category failed", res, "error");
          }
        }
        // Redirect to View
        setActionAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add File Category failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddFileCategory;
